export enum errorCode {
    AUTH_ERROR = 100,
    LOCK_ADMIN = 101,
    EXIST_ID = 110,
    EXIST_PHONE_NUMBER = 120,
    NOT_EXIST_ID = 130,
    NOT_EXIST_PHONE_NUMBER = 140,
    WRONG_PASSWORD = 150,
    WRONG_PIN_NUMBER = 160,
    WRONG_AUTH_NUMBER = 170,
    WITHDRAW_ID = 190,
    NOT_EXIST_PARAMETER = 200,
    NOT_FOUND_DATA = 300,
    DATABASE_ERROR = 400,
    PERMISSION_DENIED = 403,
    INTERNAL_ERROR = 500,
    INVAILD_DATA = 600,
    SEDN_EMAIL_FAILED = 1000,
}

export enum adminLogin {
    LOGIN = "LOGIN",
    JOIN = "JOIN",
    LOCK = "LOCK",
}

export enum loginType {
    CUSTOM = "custom",
    GOOGLE = "google",
    // TODO : 추가 해야 함.
    KAKAO = "kakao",
}

export enum quotationStatus {
    PENDING = "pending",
    APPROVED = "approved",
}

export enum orderStatus {
    PENDING = "pending",
    APPROVED = "approved",
    APPROVED_TEMP_SAVE = "approvedTempSave",
    READY = "ready",
    REJECTED = "rejected",
    ING = "ing",
    COMPLETED = "completed",
    CANCELED = "canceled",
}

export enum orderType {
    INDIVIDUAL = "individual", //개인
    BODY = "body", //기관
}

export enum projectStatus {
    PENDING = "pending",
    ING = "ing",
    COMPLETED = "completed",
    CANCELED = "canceled",
}

export const enum productCategory {
    PERSONAL = "personal",
    ORGANIZATION = "org",
    OFFLINE = "offline",
}

export enum paymentStatus {
    PENDING = "pending",
    COMPLETED = "completed",
    CANCELED = "canceled",
}

export enum paymentType {
    BANK_TRANSFER = "bank_transfer",
    CARD = "card",
    EASY_PAY = "easy_pay",
    CASH = "cash",
}

export enum boardType {
    NOTICE = "notice",
    PRESS = "press",
    QNA = "qna",
}
